import { defineMessages } from 'react-intl';

export default defineMessages({
    address: {
        id: 'ml.quoteandbind.additionalHomeLiability.address',
        defaultMessage: 'Address'
    },
    typeHeader: {
        id: 'ml.quoteandbind.additionalHomeLiability.type',
        defaultMessage: 'Type'
    },
    propertyDescription: {
        id: 'ml.quoteandbind.additionalHomeLiability.propertyDescription',
        defaultMessage: 'Property Description'
    },
    numberOfAcres: {
        id: 'ml.quoteandbind.additionalHomeLiability.numberOfAcres',
        defaultMessage: 'Number of Acres'
    },
    action: {
        id: 'ml.quoteandbind.additionalHomeLiability.action',
        defaultMessage: 'Action'
    },
    modalTitle: {
        id: 'ml.quoteandbind.additionalHomeLiability.modalTitle',
        defaultMessage: 'Add Additional Home Liability'
    },
    addressLine1: {
        id: 'ml.quoteandbind.additionalHomeLiability.addressLine1',
        defaultMessage: 'Address Line 1'
    },
    addressLine2: {
        id: 'ml.quoteandbind.additionalHomeLiability.addressLine2',
        defaultMessage: 'Address Line 2'
    },
    city: {
        id: 'ml.quoteandbind.additionalHomeLiability.city',
        defaultMessage: 'City'
    },
    zipCode: {
        id: 'ml.quoteandbind.additionalHomeLiability.zipCode',
        defaultMessage: 'Zip Code'
    },
    state: {
        id: 'ml.quoteandbind.additionalHomeLiability.state',
        defaultMessage: 'State'
    },
    addBtn: {
        id: 'ml.quoteandbind.additionalHomeLiability.addBtn',
        defaultMessage: 'Add'
    },
    edit: {
        id: 'ml.quoteandbind.additionalHomeLiability.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.additionalHomeLiability.remove',
        defaultMessage: 'Remove'
    },
    continueBtn: {
        id: 'ml.quoteandbind.additionalHomeLiability.continueBtn',
        defaultMessage: 'Continue'
    },
    errorMsg: {
        id: 'ml.quoteandbind.additionalHomeLiability.errorMsg',
        defaultMessage: 'This is a required field'
    },
});
